import { apiClient, handleApiError } from "../api";

/**
 * Serviço para controle de recebimentos do sistema
 */
const accountReceivableService = {

    /**
     * @function recordInvoice
     * @description Registra uma fatura no sistema
     * @param {Object} data - Dados da fatura
     * @returns {Object} Retorna um objeto com o resultado da operação
     * @example
     * const result = await accountReceivableService.recordInvoice({
     *     numeroDocumentoFiscal: '1234',
     *     codIntern: '1234',
     *     idConfiguration: 1,
     *     codCurrent?: '1234', // Opcional
     * });
     */
    async recordInvoice(data) {
        try {
            const response = await apiClient.post('/integracao/financas/contas-receber/escriturar-nota-fiscal', data);
            const responseData = response.data || {};

            return {
                success: responseData.success ?? true,
                data: responseData.data ?? responseData,
                message: responseData.message ?? null
            }
        } catch (error) {
            console.error(error);
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },
    
    /**
     * @function buscarPorNotaFiscal
     * @description Busca uma nota fiscal pelo seu número
     * @param {Object} data - Dados para busca da nota fiscal
     * @param {string} data.numeroDocumentoFiscal - Número da nota fiscal
     * @param {number} data.idConfiguration - ID da configuração
     * @returns {Object} Retorna um objeto com o resultado da operação
     * @example
     * const result = await accountReceivableService.buscarPorNotaFiscal({
     *     numeroDocumentoFiscal: '1234',
     *     idConfiguration: 1
     * });
     */
    async buscarPorNotaFiscal(data) {
        try {
            const response = await apiClient.post('/integracao/financas/contas-receber/buscar-por-nota-fiscal', data);
            const responseData = response.data || {};

            return {
                success: responseData.success ?? true,
                data: responseData.data ?? responseData,
                message: responseData.message ?? null
            }
        } catch (error) {
            console.error(error);
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    }

}

export default accountReceivableService;